import { proxy } from 'valtio';
import type { AccommodationType } from '../constants/accommodation';

// =============================================================================
// INQUIRY MODE FLAG
// =============================================================================
// When true, the website operates in "inquiry only" mode:
// - Booking routes are blocked and redirect to home
// - All "Book Now" CTAs open the inquiry modal instead
// - Users cannot make reservations, only submit interest
//
// Set to false once inventory is aligned and ready for real bookings
// =============================================================================
export const isInquiryModeEnabled = false;

// =============================================================================
// HIDE PRICES FLAG
// =============================================================================
// When true, prices are hidden across all tent views (cards, modals, pages)
// Set to false once prices are finalized
// =============================================================================
export const arePricesHidden = false;

interface InquiryPreferences {
  checkIn?: string;
  checkOut?: string;
  guests?: number;
  accommodationType?: AccommodationType;
}

export const inquiryModal = proxy<{
  isOpen: boolean;
  initialInquiry: string;
  preferences?: InquiryPreferences;
}>({
  isOpen: false,
  initialInquiry: '',
  preferences: undefined,
});

export const onClose = () => {
  inquiryModal.isOpen = false;
  inquiryModal.initialInquiry = '';
  inquiryModal.preferences = undefined;
};

export const onOpenInquiry = (initialInquiryOrPrefs?: string | InquiryPreferences) => {
  inquiryModal.isOpen = true;

  if (typeof initialInquiryOrPrefs === 'string') {
    inquiryModal.initialInquiry = initialInquiryOrPrefs;
    inquiryModal.preferences = undefined;
  } else if (initialInquiryOrPrefs) {
    inquiryModal.initialInquiry = '';
    inquiryModal.preferences = initialInquiryOrPrefs;
  } else {
    inquiryModal.initialInquiry = '';
    inquiryModal.preferences = undefined;
  }
};
